import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { BsArrowUp, BsArrowDown, BsArrowDownUp } from "react-icons/bs";
import { AiOutlineDownload, AiOutlineEye } from "react-icons/ai";
import ReactPaginate from "react-paginate";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Button,
  Col,
  Input,
  Label,
  Row,
  FormGroup,
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { maskMoeda } from "../../../util/masks";
import { COLUMNS } from "../constants/columns";
import * as actions from "../../../store/modules/conferenciaCp/actions";
import * as controller from "../../../controllers/conferenciaCpController";
import { Select } from "../../../components/Inputs/Input";
import ModalDetalhamento from "../components/ModalDetalhamento";
import { BiEdit } from "react-icons/bi";
import { TbCheckbox } from "react-icons/tb";
import { MdOutlineSettingsBackupRestore } from "react-icons/md";
import ModalEdicao from "../components/ModalEdicao";
import ModalResultadoLote from "../components/ModalResultadoLote";
import { Tooltip } from "@material-ui/core";
const Search = () => {
  const { search, contasPagarAgrupado, pagination, optionsSelect, download } =
    useSelector((state) => state.conferenciaCp);
  const columns = useMemo(() => COLUMNS, []);
  const data = contasPagarAgrupado;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    state,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageSize } = state;
  const [initialPage, setInitialPage] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const [selecionados, setSelecionados] = useState({});
  const [confirmacao, setConfirmacao] = useState(null);
  const [resultadoLote, setResultadoLote] = useState(null);
  const [isModalDetalhamentoOpen, setIsModalDetalhamentoOpen] = useState(false);
  const [isModalEdicaoOpen, setIsModalEdicaoOpen] = useState(false);
  const [comissaoId, setComissaoId] = useState("0");
  const toggleDetalhamento = () =>
    setIsModalDetalhamentoOpen(!isModalDetalhamentoOpen);
  const toggleEdicao = () => setIsModalEdicaoOpen(!isModalEdicaoOpen);

  const handlePageClick = async (e) => {
    const pageSelected = e.selected;
    setInitialPage(false);
    setSelectedPage(pageSelected);
    gotoPage(pageSelected);
    await controller.getContasPagarAgrupada(search, pageSize, pageSelected + 1);
  };

  useEffect(() => {
    controller.getFiltros();
    controller.getContasPagarAgrupada(search, pageSize, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleInitialPage(pageSize) {
    const pageSelected = 0;
    setInitialPage(false);
    setSelectedPage(pageSelected);
    gotoPage(pageSelected);
    await controller.getContasPagarAgrupada(search, pageSize, pageSelected + 1);
  }

  function onChange(value, field) {
    actions.setSearch(field, value);
  }

  async function getAll() {
    setSelecionados({});
    await controller.getContasPagarAgrupada(search, pageSize, 1);
    gotoPage(0);
    setInitialPage(true);
    setSelectedPage(0);
  }

  function seeRegister(id) {
    setComissaoId(id);
    toggleDetalhamento();
  }

  function editRegister(id) {
    setComissaoId(id);
    const itemSelected = contasPagarAgrupado.find((e) => e.id === id);
    actions.setItem({
      id: itemSelected.id,
      sistemaId: itemSelected.sistemaId,
      tipoRegraId: itemSelected.tipoRegraId,
      valor: itemSelected.valor,
    });
    toggleEdicao();
  }

  async function downloadRegister(id) {
    const success = await controller.downloadPlanilha(id);
    if (success) {
      document.getElementById("download").click();
    }
  }

  function recarregarPaginaAtual() {
    return controller.getContasPagarAgrupada(
      search,
      pageSize,
      (initialPage ? 0 : selectedPage || 0) + 1
    );
  }

  function removerDaSelecao(ids) {
    setSelecionados((atuais) => {
      const novos = { ...atuais };
      ids.forEach((id) => delete novos[id]);
      return novos;
    });
  }

  async function executarConfirmacao() {
    const { acao, contas, emLote } = confirmacao;
    setConfirmacao(null);

    if (emLote) {
      const resultado =
        acao === "aprovar"
          ? await controller.aprovarContas(contas)
          : await controller.estornarContas(contas);
      const idsFalhas = resultado.falhas.map((falha) => falha.conta.id);
      removerDaSelecao(
        contas.map((conta) => conta.id).filter((id) => !idsFalhas.includes(id))
      );
      if (resultado.falhas.length > 0) {
        const falhas = await controller.getStatusAtualFalhas(resultado.falhas);
        setResultadoLote({ acao, sucessos: resultado.sucessos, falhas });
      }
    } else {
      const [conta] = contas;
      const executou =
        acao === "aprovar"
          ? await controller.aprovarConta(conta.id)
          : await controller.estornarConta(conta.id);
      if (executou) {
        removerDaSelecao([conta.id]);
      }
    }

    await recarregarPaginaAtual();
  }

  function isPendente(conta) {
    return conta.status.toUpperCase() === "PENDENTE";
  }

  function handleSelectContaPagar(conta) {
    const novos = { ...selecionados };
    if (novos[conta.id]) {
      delete novos[conta.id];
    } else {
      novos[conta.id] = conta;
    }
    setSelecionados(novos);
  }

  const pendentesDaPagina = data.filter(isPendente);
  const todosDaPaginaSelecionados =
    pendentesDaPagina.length > 0 &&
    pendentesDaPagina.every((conta) => selecionados[conta.id]);

  function handleSelectAllContasPagar() {
    const novos = { ...selecionados };
    pendentesDaPagina.forEach((conta) => {
      if (todosDaPaginaSelecionados) {
        delete novos[conta.id];
      } else {
        novos[conta.id] = conta;
      }
    });
    setSelecionados(novos);
  }

  const listaSelecionados = Object.values(selecionados);

  function descreverConta(conta) {
    return `${conta.campanha} / ${conta.empresa}`;
  }

  function somarValores(contas) {
    return maskMoeda(
      contas.reduce((total, conta) => total + (conta.valor || 0), 0).toFixed(2)
    );
  }

  return (
    <>
      <Col>
        <Card className="pt-3 pb-2 mb-5 ml-4">
          <div className="container-fluid px-3">
            <Row>
              <Col className="d-flex flex-column">
                <div className="mb-3">
                  <Label className="cp-titulo-pesquisa">Pesquisar</Label>
                </div>
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Campanha</Label>
                      <Select
                        first="Selecione"
                        value={{ value: search.campanhaPremiacaoId }}
                        select={{ value: "id", label: "descricao" }}
                        options={optionsSelect.campanhas}
                        onChange={(e) => {
                          onChange(e.value, "campanhaPremiacaoId");
                        }}
                        isSearchable={true}
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup>
                      <Label>Empresa</Label>
                      <Select
                        first="Selecione"
                        value={{ value: search.empresaId }}
                        select={{ value: "id", label: "razaoSocialEmpresa" }}
                        options={optionsSelect.empresas}
                        onChange={(e) => {
                          onChange(e.value, "empresaId");
                        }}
                        isSearchable={true}
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Tipo Pagamento</Label>
                      <Select
                        first="Selecione"
                        value={{ value: search.tipoRegraId }}
                        select={{ value: "id", label: "descricao" }}
                        options={optionsSelect.tiposPagamento}
                        onChange={(e) => {
                          onChange(e.value, "tipoRegraId");
                        }}
                        isSearchable={true}
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Data Aceite</Label>
                      <Input
                        type="date"
                        value={search.dataAceito}
                        onChange={(e) => onChange(e.target.value, "dataAceito")}
                        autoComplete="true"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Sistema</Label>
                      <Select
                        first="Selecione"
                        value={{ value: search.sistemaId }}
                        select={{ value: "id", label: "nome" }}
                        options={optionsSelect.sistemas}
                        onChange={(e) => {
                          onChange(e.value, "sistemaId");
                        }}
                        isSearchable={true}
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Status</Label>
                      <Select
                        first="Selecione"
                        value={{ value: search.statusId }}
                        select={{ value: "id", label: "descricao" }}
                        options={optionsSelect.status.filter((option) =>
                          [
                            "aprovado",
                            "estornado",
                            "pendente",
                            "integrado",
                          ].includes(option.descricao.toLowerCase())
                        )}
                        onChange={(e) => {
                          onChange(e.value, "statusId");
                        }}
                        isSearchable={true}
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="align-items-center mt-1">
                  <Col md={2}>
                    <Button
                      className="cp-botao cp-botao-limpar"
                      onClick={actions.cleanSearch}
                    >
                      Limpar
                    </Button>
                  </Col>
                  <Col md={2}>
                    <Button
                      className="purpleButton cp-botao"
                      onClick={() => getAll()}
                    >
                      Buscar
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="d-flex flex-grow-1 mw-100 overflow-auto m-5">
                  <table {...getTableProps()}>
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          <th className="cp-coluna-selecao">
                            <div className="cp-selecao-todos">
                              <input
                                className="cp-checkbox-todos"
                                type="checkbox"
                                checked={todosDaPaginaSelecionados}
                                onChange={() => handleSelectAllContasPagar()}
                              />
                            </div>
                          </th>
                          {headerGroup.headers.map((column) => (
                            <th key={column.id} className="cp-coluna">
                              <span className="float-left">
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <BsArrowDown
                                      {...column.getHeaderProps(
                                        column.getSortByToggleProps({
                                          title: undefined,
                                        })
                                      )}
                                    />
                                  ) : (
                                    <BsArrowUp
                                      id="OrdenarAsc"
                                      {...column.getHeaderProps(
                                        column.getSortByToggleProps({
                                          title: undefined,
                                        })
                                      )}
                                    />
                                  )
                                ) : (
                                  <BsArrowDownUp
                                    {...column.getHeaderProps(
                                      column.getSortByToggleProps({
                                        title: undefined,
                                      })
                                    )}
                                  />
                                )}
                              </span>
                              {column.render("Header")}
                            </th>
                          ))}
                          <th className="cp-coluna-acoes">Ações</th>
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr
                            className="text-center"
                            {...row.getRowProps()}
                            index={row.original.id}
                          >
                            <td>
                              {row.original.status.toUpperCase() ===
                                "PENDENTE" && (
                                <input
                                  type="checkbox"
                                  className="cp-checkbox-linha"
                                  checked={!!selecionados[row.original.id]}
                                  onChange={() =>
                                    handleSelectContaPagar(row.original)
                                  }
                                />
                              )}
                            </td>
                            {row.cells.map((cell) => {
                              return (
                                <td {...cell.getCellProps()}>
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                            <td>
                              <div className="d-flex justify-content-center gap-2">
                                <Tooltip title="Visualizar" arrow>
                                  <span>
                                    <AiOutlineEye
                                      className="cp-icone-acao"
                                      onClick={() =>
                                        seeRegister(row.original.id)
                                      }
                                    />
                                  </span>
                                </Tooltip>
                                {row.original.status.toUpperCase() ===
                                  "PENDENTE" && (
                                  <Tooltip title="Editar" arrow>
                                    <span>
                                      <BiEdit
                                        className="cp-icone-acao"
                                        onClick={() =>
                                          editRegister(row.original.id)
                                        }
                                      />
                                    </span>
                                  </Tooltip>
                                )}
                                {row.original.status.toUpperCase() !==
                                  "ESTORNADO" && (
                                  <Tooltip title="Baixar planilha" arrow>
                                    <span>
                                      <AiOutlineDownload
                                        className="cp-icone-acao"
                                        onClick={() =>
                                          downloadRegister(row.original.id)
                                        }
                                      />
                                    </span>
                                  </Tooltip>
                                )}

                                {row.original.status.toUpperCase() ===
                                  "PENDENTE" && (
                                  <Tooltip title="Estornar" arrow>
                                    <span>
                                      <MdOutlineSettingsBackupRestore
                                        className="cp-icone-estornar"
                                        onClick={() =>
                                          setConfirmacao({
                                            acao: "estornar",
                                            contas: [row.original],
                                            emLote: false,
                                          })
                                        }
                                      />
                                    </span>
                                  </Tooltip>
                                )}
                                {row.original.status.toUpperCase() ===
                                  "PENDENTE" && (
                                  <Tooltip title="Aprovar" arrow>
                                    <span>
                                      <TbCheckbox
                                        className="cp-icone-aprovar"
                                        onClick={() =>
                                          setConfirmacao({
                                            acao: "aprovar",
                                            contas: [row.original],
                                            emLote: false,
                                          })
                                        }
                                      />
                                    </span>
                                  </Tooltip>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <Row className="pt-4">
                  <Col>
                    <span className="cp-texto-secundario">
                      Mostrando{" "}
                      {pagination.quantidade ? pagination.quantidade : "0"} de{" "}
                      {pagination.quantidadeTotal
                        ? pagination.quantidadeTotal
                        : "0"}
                    </span>
                  </Col>
                  <Col md={8}>
                    <Row className="float-right">
                      <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pagination.totalPaginas}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={initialPage ? 0 : selectedPage}
                      />
                      <Input
                        type="select"
                        className="pageSize"
                        value={pageSize}
                        onChange={(e) => {
                          handleInitialPage(Number(e.target.value));
                          setPageSize(Number(e.target.value));
                        }}
                      >
                        {[10, 25, 100].map((pageSize) => (
                          <option key={pageSize} value={pageSize}>
                            {pageSize}
                          </option>
                        ))}
                      </Input>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="align-items-center justify-content-end mt-5">
              <Col md={2}>
                <Button
                  className="purpleButton cp-botao-lote"
                  disabled={listaSelecionados.length === 0}
                  onClick={() =>
                    setConfirmacao({
                      acao: "aprovar",
                      contas: listaSelecionados,
                      emLote: true,
                    })
                  }
                >
                  Aprovar itens selecionados
                  {listaSelecionados.length > 0
                    ? ` (${listaSelecionados.length})`
                    : ""}
                </Button>
              </Col>
              <Col md={2}>
                <Button
                  className="cp-botao-lote cp-botao-estornar"
                  disabled={listaSelecionados.length === 0}
                  onClick={() =>
                    setConfirmacao({
                      acao: "estornar",
                      contas: listaSelecionados,
                      emLote: true,
                    })
                  }
                >
                  Estornar itens selecionados
                  {listaSelecionados.length > 0
                    ? ` (${listaSelecionados.length})`
                    : ""}
                </Button>
              </Col>
            </Row>
          </div>
          <Modal
            isOpen={confirmacao !== null}
            toggle={() => setConfirmacao(null)}
            className="text-center"
          >
            <ModalHeader toggle={() => setConfirmacao(null)}>
              {confirmacao?.acao === "aprovar"
                ? "Confirmar aprovação"
                : "Confirmar estorno"}
            </ModalHeader>
            <ModalBody>
              {confirmacao && (
                <>
                  <p>
                    Você está prestes a{" "}
                    <strong>{confirmacao.acao}</strong>{" "}
                    {confirmacao.contas.length === 1 ? (
                      <>
                        a conta{" "}
                        <strong>
                          {descreverConta(confirmacao.contas[0])}
                        </strong>
                      </>
                    ) : (
                      <>
                        <strong>{confirmacao.contas.length}</strong> contas
                      </>
                    )}
                    .
                  </p>
                  <p>
                    Valor total:{" "}
                    <strong>R$ {somarValores(confirmacao.contas)}</strong>
                  </p>
                  <p className="cp-aviso-irreversivel">
                    Essa ação não pode ser desfeita: a conta não volta para
                    Pendente.
                  </p>
                </>
              )}
            </ModalBody>
            <ModalFooter className="justify-content-center">
              <Button color="danger" onClick={() => setConfirmacao(null)}>
                Cancelar
              </Button>
              <Button
                className="cp-botao-confirmar"
                onClick={() => executarConfirmacao()}
              >
                Confirmar
              </Button>
            </ModalFooter>
          </Modal>
          <ModalResultadoLote
            resultado={resultadoLote}
            toggle={() => setResultadoLote(null)}
          />
          {
            <ModalDetalhamento
              isOpen={isModalDetalhamentoOpen}
              toggle={toggleDetalhamento}
              id={comissaoId}
            />
          }
          {
            <ModalEdicao
              isOpen={isModalEdicaoOpen}
              toggle={toggleEdicao}
              id={comissaoId}
              pagination={{
                search: search,
                pageSize: pageSize,
                selectedPage: selectedPage + 1,
              }}
            />
          }
        </Card>
      </Col>
      <div className="d-none">
        <a
          id="download"
          href={`data:application/pdf;base64,${download.arquivoBase64}`}
          download={download.nomeArquivo}
        >
          .
        </a>
      </div>
    </>
  );
};

export default Search;
